import React from "react";

const POLICY_SECTIONS = [
  {
    title: "Information We Collect",
    points: [
      "Basic contact details you submit through enquiry, contact, or admissions forms.",
      "Academic and student-related details shared for school administration.",
      "Technical information such as browser/device data for site performance and security.",
    ],
  },
  {
    title: "How We Use Your Information",
    points: [
      "To process admissions, communication, and student-related service requests.",
      "To improve website content, support, and user experience.",
      "To maintain records required for school operations and compliance.",
    ],
  },
  {
    title: "Data Protection",
    points: [
      "We use administrative, technical, and operational safeguards to protect data.",
      "Access to personal data is restricted to authorized personnel only.",
      "Despite best efforts, internet-based systems cannot guarantee absolute security.",
    ],
  },
  {
    title: "Policy Updates",
    points: [
      "This policy may be revised when school processes, legal requirements, or digital systems change.",
      "Updated policy versions are published on this page with the latest update date.",
    ],
  },
];

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-8 sm:px-6 lg:px-10">
      <div className="mx-auto max-w-5xl space-y-6">
        <section className="rounded-3xl bg-gradient-to-r from-blue-900 via-blue-800 to-blue-700 p-8 text-white shadow-xl">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-blue-100">
            Legal
          </p>
          <h1 className="mt-3 text-3xl font-semibold text-white sm:text-4xl">
            Privacy Policy
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-6 text-blue-100 sm:text-base">
            Rising Stars Public School respects your privacy and handles your
            data responsibly in line with school operations and safety
            standards.
          </p>
          <div className="mt-5 inline-flex rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.14em] text-blue-100">
            Last Updated: March 20, 2026
          </div>
        </section>

        <section className="grid gap-5">
          {POLICY_SECTIONS.map((section) => (
            <article
              key={section.title}
              className="rounded-3xl border border-slate-200 bg-white p-6 shadow-md"
            >
              <h2 className="text-2xl font-semibold text-slate-900">
                {section.title}
              </h2>
              <ul className="mt-4 space-y-2 text-sm leading-6 text-slate-700 sm:text-base">
                {section.points.map((point) => (
                  <li
                    key={point}
                    className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3"
                  >
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
